import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi, KSeFSubmissionDetailDto } from "./ksefApi";

export const useKsefSubmission = (integrationId: number, submissionId: number) => {
  const { isLoading, data } = useQuery<KSeFSubmissionDetailDto>({
    queryKey: QUERIES_KEYS.KSEF_SUBMISSION_BY_ID(integrationId, submissionId),
    queryFn: () => ksefApi.fetchSubmission(integrationId, submissionId).then((r) => r.data),
    enabled: integrationId > 0 && submissionId > 0,
  });

  return { isLoading, submission: data };
};
